import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import CustomSelect from "../CustomComponents/CustomSelect";
import { dateTransformation } from '../../utils.js'
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import {checkAuthentication} from '../../utils';

export default function EditRoleDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [LockedAlert, setAlert] = React.useState(false);

    const [userChoices, setUserChoices] = React.useState([
    ])

    const [labChoices, setLabChoices] = React.useState([
    ])

    const [positionChoices, setPositionChoices] = React.useState([
    ])

    const initialValues = {
        name: data.UserID,
        labID: data.LabID,
        positionID: data.PositionID,
        start: moment.utc(data.StartDate).format("MM/DD/YYYY"),
        end: moment.utc(data.EndDate).format("MM/DD/YYYY"), 
        isActive: data.IsActive ? true : false

    };

    const validFormSchema = Yup.object({
        name: Yup
            .string('Enter a name for the position')
            .required('Position name is required'),
        labID: Yup
            .string('Enter a name for the position')
            .required('Position name is required'),
        positionID: Yup
            .string('Enter a name for the position')
            .required('Position name is required'),
        start: Yup
            .date("Enter a start date for the amendment mm/dd/yyyy")
            .required("Start date required mm/dd/yyyy"),
        end: Yup
            .date("Enter an end date for the amendment mm/dd/yyyy")
            .required("End date required mm/dd/yyyy"),
        isActive: Yup
            .boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            UserID: values.name,
            LabID: values.labID,
            PositionID: values.positionID,
            StartDate: moment.utc(values.start),
            EndDate: moment.utc(values.end),
            IsActive: values.isActive
        };
		if( ( moment.utc(values.start)>moment.utc(values.end))){
					setAlert(true);
				} else {
        handleEditCallback(msg);
        handleClose();
        }
    })

	const handleAlertClose = () => {
	        setAlert(false);
	    };
	    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const getUserChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.FirstName + " " + choice.LastName, value: choice.ID }))
        setUserChoices(choices)
    };

    const getLabChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setLabChoices(choices)
    };

    const getPositionChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setPositionChoices(choices)
    };

    React.useEffect(() => {		
		if (open){
		checkAuthentication();
		}
        if (refresh) {
            fetch('api/position/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => getPositionChoices(json))

            fetch('api/lab/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => getLabChoices(json))

            fetch('api/User/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => getUserChoices(json))

            setRefresh(false);
        }
    })



    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit" placement="top-end">
                <IconButton variant="contained" onClick={handleClickOpen} >
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Role
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Role Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-name">User</InputLabel>
                                        <CustomSelect
                                            name="name"
                                            id="outlined-name"
                                            options={userChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.name}
                                            error={props.touched.Name && Boolean(props.errors.name)}
                                            helperText={props.touched.name && props.errors.name}
                                            label="User"
                                            disabled={data.locked}
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-Lab">Lab</InputLabel>
                                        <CustomSelect
                                            name="labID"
                                            id="outlined-Lab"
                                            options={labChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.labID}
                                            error={props.touched.labID && Boolean(props.errors.labID)}
                                            helperText={props.touched.labID && props.errors.labID}
                                            label="Lab"
                                            disabled={data.locked}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <InputLabel htmlFor="outlined-Position">Position</InputLabel>
                                        <CustomSelect
                                            name="positionID"
                                            id="outlined-Position"
                                            options={positionChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.positionID}
                                            error={props.touched.positionID && Boolean(props.errors.positionID)}
                                            helperText={props.touched.positionID && props.errors.positionID}
                                            label="Position"
                                            disabled={data.locked}
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name="start"
                                            id="outlined-startDate"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            type= "date"
                                            value={props.values.start.indexOf("/")>0?dateTransformation(props.values.start):props.values.start}
                                            error={props.touched.start && Boolean(props.errors.start)}
                                            helperText={props.touched.start && props.errors.start}
                                            label="Start Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>

                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name="end"
                                            id="outlined-endDate"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            type= "date"
                                            value={props.values.end.indexOf("/")>0?dateTransformation(props.values.end):props.values.end}
                                            error={props.touched.end && Boolean(props.errors.end)}
                                            helperText={props.touched.end && props.errors.end}
                                            label="End Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="isActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.isActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                 <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="Date Alert"
                    aria-describedby="Start Date before the End Date"
                >
                    <DialogTitle id="Date Alert">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {"Start Date should be before the End Date, Please enter different time period"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>     
            </Dialog></MuiThemeProvider>
        </div>
    );
}